export const TOPIC_GROUPS = {
  fundamentals: [
    'Array',
    'String',
    'Hash Table',
    'Math',
    'Sorting',
    'Greedy',
    'Two Pointers',
    'Sliding Window',
    'Prefix Sum',
    'Counting',
    'Simulation',
  ],
  searchAndTraversal: [
    'Depth-First Search',
    'Breadth-First Search',
    'Binary Search',
    'Backtracking',
    'Recursion',
    'Enumeration',
  ],
  linearStructures: [
    'Stack',
    'Queue',
    'Linked List',
    'Doubly-Linked List',
    'Monotonic Stack',
    'Monotonic Queue',
    'Data Stream',
    'Iterator',
  ],
  treesAndGraphs: [
    'Tree',
    'Binary Tree',
    'Binary Search Tree',
    'Trie',
    'Graph Theory',
    'Shortest Path',
    'Topological Sort',
    'Union-Find',
    'Minimum Spanning Tree',
    'Eulerian Circuit',
    'Strongly Connected Component',
    'Biconnected Component',
  ],
  dpAndCombinatorics: [
    'Dynamic Programming',
    'Memoization',
    'Combinatorics',
    'Game Theory',
    'Probability and Statistics',
    'Number Theory',
  ],
  advancedDataStructures: [
    'Heap (Priority Queue)',
    'Segment Tree',
    'Ordered Set',
    'Binary Indexed Tree',
    'Bitmask',
    'Bit Manipulation',
    'Hash Function',
    'Rolling Hash',
    'Suffix Array',
  ],
  algorithmDesign: [
    'Divide and Conquer',
    'Quickselect',
    'Merge Sort',
    'Counting Sort',
    'Bucket Sort',
    'Radix Sort',
    'Shell',
    'Sweep Line',
    'Randomized',
    'Reservoir Sampling',
    'Rejection Sampling',
    'Geometry',
  ],
  systemsAndSpecial: [
    'Database',
    'Design',
    'Matrix',
    'String Matching',
    'Interactive',
    'Brainteaser',
    'Concurrency',
  ],
};

export const ALL_TOPICS = Object.values(TOPIC_GROUPS).flat();
